import React, { useMemo, useState } from 'react'

import { Button, InputNumber, message } from 'antd'

import { getApiTargetInfo } from 'core'
import {
  getUtilityNameMap,
  getUnitNameMap,
  getPermitActions,
  getEnvConfig,
} from 'core/selectors'

import { Label } from 'core/screen-util'
import { SppAcaNotExcCausecodeHeaders } from './ACAHeaders'
import { deletecausecode, getcausecode, postcausecode } from './acaapi'
import { connect } from 'react-redux'
import CommonScreen from 'admin/component/CommonScreen'
import { getCauseCodeMap } from '../../core/selectors'

const ACACausecode = props => {
  const [insertEvent, setInsertEvent] = useState(false)

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => {
    return (
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '100px 150px 150px 150px 150px 10px auto',
          gap: 5,
          width: '100%',
        }}
      >
        <Label>Cause Code :</Label>
        <InputNumber
          value={insertData.causecode}
          onChange={val => setInsertData({ ...insertData, causecode: val })}
        />

        <Button type="primary" onClick={() => onAdd(true)}>
          Add
        </Button>

        <Button
          type="primary"
          onClick={() => onAdd(false)}
          style={{ marginLeft: '20px' }}
        >
          Add & Hide
        </Button>
        <Button type="danger" onClick={onCancel} style={{ marginLeft: '20px' }}>
          Cancel
        </Button>
        <div />
        <div>
          Cause Description :{' '}
          {props.causeCodeMap[insertData.causecode || ''] || 'Not Found'}
        </div>
      </div>
    )
  }

  const isValidate = data => {
    const valid = data.find(d => props.causeCodeMap[d.causecode])
    if (!valid) {
      message.error('Cause Code not found.')
      return false
    }
    return data
  }
  const insertValidation = data => isValidate([data])

  // const modifySaveDataBeforeSave = data => isValidate(data)

  const headerWithFormatter = useMemo(
    _ => {
      return SppAcaNotExcCausecodeHeaders.map(header =>
        header.ident === 'description'
          ? {
              ...header,
              // ...toSelectionColProps(props.causeCodeMap),
              dataFormatter: ({ rowData }) =>
                props.causeCodeMap[rowData.causecode],
              dataGetter: ({ rowData }) =>
                props.causeCodeMap[rowData.causecode],
            }
          : header
      )
    },
    [props.causeCodeMap]
  )

  return (
    <CommonScreen
      // modifySaveDataBeforeSave={modifySaveDataBeforeSave}
      insertValidation={insertValidation}
      title="SPP Non-OMC Cause Codes"
      header={headerWithFormatter}
      initialSortOptions={headerWithFormatter}
      saveTask={postcausecode}
      retrieveTask={getcausecode}
      deleteTask={deletecausecode}
      altBy={d => d.causecode}
      autoRetrieve
      insertComp={insertEvent && insertComp}
      insertCompHeight={90}
      onInsertEvent={b => setInsertEvent(b)}
      headerRowHeight={30}
      isEditableGrid={_ => false}

      // widthOffset={550}
      // heightOffset={100}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
  permitActions: getPermitActions(state),
  envConfig: getEnvConfig(state),
  causeCodeMap: getCauseCodeMap(state),
})

export default connect(mapStateToProps)(ACACausecode)
